module.exports = __webpack_public_path__ + "img/vertical_4_6_2.a5e88ab6.png";